// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore asd
// eslint-disable-next-line import/no-unresolved
import config from './config.json';

export type Config = {
  amsHostedZoneName: string;
  enrolmentPlannerHostedZoneName: string;
};

export function getConfig(): Config {
  return {
    amsHostedZoneName: config.amsHostedZoneName,
    enrolmentPlannerHostedZoneName: config.enrolmentPlannerHostedZoneName,
  };
}
